import { Notification } from '@/types/notification';

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: '1',
    title: 'Welcome to NezenX Admin',
    message: 'You have successfully logged into the admin panel. Explore all the features available.',
    time: '2 minutes ago',
    timestamp: new Date(Date.now() - 2 * 60 * 1000),
    isRead: false,
    type: 'success',
    userId: 'user1',
    actionUrl: '/dashboard',
    metadata: { priority: 'high' }
  },
  {
    id: '2',
    title: 'New User Registration',
    message: 'A new user "John Doe" has registered on the platform.',
    time: '15 minutes ago',
    timestamp: new Date(Date.now() - 15 * 60 * 1000),
    isRead: false,
    type: 'info',
    userId: 'user1',
    actionUrl: '/users',
    metadata: { userId: 'user123' }
  },
  {
    id: '3',
    title: 'Payment Received',
    message: 'Payment of $299.00 has been successfully processed.',
    time: '1 hour ago',
    timestamp: new Date(Date.now() - 60 * 60 * 1000),
    isRead: true,
    type: 'success',
    userId: 'user1',
    actionUrl: '/payments',
    metadata: { amount: 299.00, currency: 'USD' }
  },
  {
    id: '4',
    title: 'System Maintenance',
    message: 'Scheduled maintenance will occur tonight from 2:00 AM to 4:00 AM.',
    time: '3 hours ago',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000),
    isRead: true,
    type: 'warning',
    userId: 'user1',
    actionUrl: '/maintenance',
    metadata: { maintenanceWindow: '2:00 AM - 4:00 AM' }
  },
  {
    id: '5',
    title: 'Security Alert',
    message: 'Unusual login activity detected from a new device.',
    time: '5 hours ago',
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000),
    isRead: false,
    type: 'error',
    userId: 'user1',
    actionUrl: '/security',
    metadata: { device: 'iPhone 14', location: 'New York' }
  },
  {
    id: '6',
    title: 'Feature Update',
    message: 'New dashboard analytics feature is now available.',
    time: '1 day ago',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000),
    isRead: true,
    type: 'info',
    userId: 'user1',
    actionUrl: '/features',
    metadata: { feature: 'analytics' }
  },
  {
    id: '7',
    title: 'Subscription Renewal',
    message: 'Your premium subscription will renew in 7 days.',
    time: '2 days ago',
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    isRead: false,
    type: 'warning',
    userId: 'user1',
    actionUrl: '/subscription',
    metadata: { renewalDate: '2024-01-15' }
  },
  {
    id: '8',
    title: 'Data Export Complete',
    message: 'Your data export has been completed and is ready for download.',
    time: '3 days ago',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    isRead: true,
    type: 'success',
    userId: 'user1',
    actionUrl: '/exports',
    metadata: { exportId: 'exp_123', fileSize: '2.5MB' }
  }
];

// Utility function to format relative time
export const formatRelativeTime = (timestamp: Date): string => {
  const now = new Date();
  const diff = now.getTime() - timestamp.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return 'Just now';
  } else if (minutes < 60) {
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else if (hours < 24) {
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (days < 7) {
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else {
    return timestamp.toLocaleDateString();
  }
};
